function homeOnload() {

    //animação scroll down do slider da home
    var toScrollDownAnime = anime({
        targets: '.header-scroll-down__arrow',
        easing: 'easeInOutQuad',
        duration: 500,
        direction: 'alternate',
        loop: true,
        translateY: [-2, 2],
    });

    /*
     * CALENDAR & GEOLOCATION
     */
    //$('#calendarRender').append(loaderCalContent).fadeIn(500);
    //geoLocation();

    // parametros para render calendar
    function configLatLong(e) {
        return e.toString().replace(/[.]/, '').replace(/[-]/, '').substring(0, 4);
    }

    function geoLocation() {

        if (screen.width < 640 || screen.height < 480 || screen.width <= 1024 || screen.height < 768) {

            if ('geolocation' in navigator) {

                navigator.geolocation.getCurrentPosition(function (position) {
                    var latitude = configLatLong(position.coords.latitude);
                    var longitude = configLatLong(position.coords.longitude);

                    var minLati = 2262; //-22.62
                    var maxLati = 2266; //-22.66
                    var minLong = 4783; //-47.83
                    var maxLong = 4787; //-47.87

                    if (latitude > minLati && latitude < maxLati && longitude > minLong && longitude < maxLong) {
                        console.log("GeoLocation: Dentro do parque");
                        calendarRender("start=ticket&skipCurrentDay=true");
                    } else {
                        console.log("GeoLocation: Fora do Parque");
                        calendarRender("start=ticket&skipCurrentDay=false");
                    }

                }, function (error) {
                    console.log("Not GeoLocation");
                    calendarRender("start=ticket&skipCurrentDay=true");
                });
            } else {
                console.log("Not GeoLocation");
                calendarRender("start=ticket&skipCurrentDay=true");
            }
        } else {
            console.log("desktop");
            calendarRender("start=ticket&skipCurrentDay=false");
        }
    }

    // CAROUSEL
    $('.home-carousel__box').slick({
        arrows: false,
        dots: false,
        autoplay: true,
        lazyLoad: 'ondemand',
        slidesToShow: 5,
        slidesToScroll: 1,
        infinite: true,
        autoplaySpeed: 1500,
        responsive: [
            {
                breakpoint: 1440,
                settings: {
                    slidesToShow: 4,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 4,
                }
            },
            {
                breakpoint: 539,
                settings: {
                    slidesToShow: 2,

                }
            }
        ]
    });


}